// Manually reloading widget because Facebook Pages API does not support resizing
//https://developers.facebook.com/docs/plugins/page-plugin

 $(window).on('resize', QGIV.Utilities.debounce(function() {
    if ( typeof FB !== 'undefined') {
        FB.XFBML.parse(document.body);
    }
  },500));